import { Typography } from '@material-ui/core';
import React from 'react';

const LicensePlateTag = ({isSelected, license_plate, color, backgroundColor}) => {
  return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center'}}>
          <Typography
            style={{
              backgroundColor: `${backgroundColor}`,
              padding: '1px 4px',
              fontSize: '12px',
              width: 'max-content !important',
              borderRadius: '0.1em',
              color: `${color}`,
              fontWeight: 'bold',
              margin: '0 auto',
              marginLeft: '3px',
            }}
          >
            {license_plate}
          </Typography>
          {/* {isSelected && (
            <img
              src="/static/iconSvg/focusIcon.svg"
              alt="focus"
              style={{
                display: 'block',
                margin: '0 auto',
              }}
            />
          )} */}
        </div>
  );
};

export default React.memo(LicensePlateTag);
